import type { Definition } from "../../services/types";
import { formatIST, useReadAgo } from "../../lib/readAgo";

// The always-visible foot of every page with numbers: what each one means,
// where it is read from, how it is computed, and when it was read.

type Props = {
  ids: string[];
  definitions?: Record<string, Definition>;
  readAt?: string | null;
};

export function DefinitionsPanel({ ids, definitions, readAt }: Props) {
  const readAgo = useReadAgo(readAt);
  // Tile order first, then anything else the backend attached, each id once.
  const order: string[] = [];
  const seen = new Set<string>();
  for (const id of [...ids, ...Object.keys(definitions ?? {})]) {
    if (!seen.has(id) && definitions?.[id]) {
      seen.add(id);
      order.push(id);
    }
  }

  return (
    <section className="section compact">
      <div className="shead">
        <h2 className="stitle">How these numbers are made</h2>
      </div>
      {order.length === 0 ? (
        <p className="empty">No definitions were sent with this page.</p>
      ) : (
        <dl className="defs">
          {order.map((id) => {
            const d = definitions![id];
            return (
              <div className="def" key={id}>
                <dt>{d.label}</dt>
                <dd>
                  <p>{d.meaning}</p>
                  <p className="src"><span>From</span>{d.source}</p>
                  <p className="src"><span>Computed</span>{d.computed}</p>
                </dd>
              </div>
            );
          })}
        </dl>
      )}
      {readAt ? (
        <p className="defs-foot">Read at {formatIST(readAt)}, {readAgo}.</p>
      ) : null}
    </section>
  );
}
